import {getPlayerHexColor} from '../players/getPlayerHexColor';
import {getReadableInkColor} from '../colors/getReadableInkColor';

/**
 * CSS-переменные цвета игрока для элементов «моего» в дизайн-системе матча:
 * эмаль и рамка берут --gui-pc, подпись и иконки — --gui-pc-ink (см.
 * src/styles/gameUi/tokens.css)
 * @param {string} [playerColor] - цвет игрока (PLAYER_COLORS) или готовый '#rrggbb'
 * @returns {Object|undefined} объект для style; без цвета — undefined
 *   (элемент берет значения по умолчанию из токенов)
 */
export const getPlayerColorStyle = (playerColor) => {
  if (!playerColor) {
    return undefined;
  }
  const hex = playerColor.startsWith('#') ? playerColor : getPlayerHexColor(playerColor);
  return {
    '--gui-pc': hex,
    '--gui-pc-ink': getReadableInkColor(hex),
  };
};
